import "core-js/stable";
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { DoctorSearch, SearchProvider, FadBlock } from '@ochsner/ochsner-yext-application';



function App() {
  const fadBlockEl = document.querySelector('fad-block');
  const blockTitle = fadBlockEl?.getAttribute('blockTitle');
  const blockIntro = fadBlockEl?.getAttribute('blockIntro');

  return (
    <SearchProvider
      configs={{
	    configId: 1045093249,
        experienceKey: process.env.YEXT_PUBLIC_EXPERIENCE_KEY || 'ochsner-global-search',
        verticalKey: 'healthcare_professionals',
        headlessId: 'main-doctor-search', // example
        publicApiKey: process.env.YEXT_PUBLIC_SEARCH_API_KEY,
        mapboxToken: process.env.YEXT_PUBLIC_MAPBOX_TOKEN,
        openScheduling: {
            apiKey: process.env.YEXT_PUBLIC_EPIC_OPENSCHEDULINGSIMPLE_KEY,
            url: process.env.YEXT_PUBLIC_EPIC_OPENSCHEDULINGSIMPLE_URL
	    }
      }}
    >
      {!fadBlockEl && <DoctorSearch />}
      {fadBlockEl && ReactDOM.createPortal(
        <FadBlock blockTitle={blockTitle} blockIntro={blockIntro} />,
        fadBlockEl
      )}
    </SearchProvider>

  );
}

export default App;
